import React from 'react';
import Enumerable from 'linq';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { WindowResizeListener } from 'react-window-resize-listener';
import classNames from 'classnames';
import styles from './styles/Header.sass';

class Header extends React.Component {
  constructor() {
    super();

    this.state = {
      isOpen: false,
    }
  }

  componentDidMount() {
    const { getHeader } = this.props;

    getHeader();
  }

  toggleMenu(isOpen) {
    this.setState({
      isOpen: isOpen,
    }, () => {
      $(`body, .${styles.menu}`).animate({
        'marginLeft': `-${isOpen ? 150 : 0}px`
      }, 300);
    });
  }

  render() {
    const {
      twitter,
      youtube,
    } = this.props;

    return (
      <header className={styles.header}>
        <WindowResizeListener
          onResize={
            () => {
              this.toggleMenu(false);
            }
          }
        />
        <img
          className={styles.logo}
          src={require('images/logo.png')}
          alt='logo'
        />
        <ul className={styles.link}>
          <li>
            <a
              href={twitter}
              target="_blank"
            >
              <img
                src={require('images/twitter.png')}
                alt="twitter"
              />
            </a>
          </li>
          <li>
          <a
          href={youtube}
          target="_blank"
        >
          <img
            src={require('images/youtube.png')}
            alt="youtube"
          />
        </a>
      </li>
        </ul>
        <div className={styles.menu}>
            <div
              className={classNames(
                styles.burger,
                this.state.isOpen ? styles.isOpen : '',
              )}
              onClick={
                () => {
                  this.toggleMenu(!this.state.isOpen);
                }
              }
            >
              <span />
              <span />
              <span />
            </div>
            <ul>
              {
                Enumerable
                  .from([
                    {
                      imageName: 'menu-top.png',
                      url: '',
                    },
                    {
                      imageName: 'menu-story.png',
                      url: 'story',
                    },
                    {
                      imageName: 'menu-cd.png',
                      url: 'cd',
                    },
                    {
                      imageName: 'menu-goods.png',
                      url: 'goods',
                    },
                  ])
                  .select((element) => (
                    <li key={element.url}>
                      <Link
                        to={`/${element.url}`}
                        onClick={
                          () => {
                            this.toggleMenu(false);
                          }
                        }
                      >
                        <img
                          src={require('images/' + element.imageName)}
                          alt={element.imageName}
                        />
                      </Link>
                    </li>
                  ))
                  .toArray()
              }
            </ul>
          </div>
      </header>
        );
  }
}

export default Header



// WEBPACK FOOTER //
// src/components/common/Header.js